import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const ArrowUp = forwardRef<Ref, IconPropsType>(({ color = "currentColor", size, ...rest }, ref) => {
  return (
    <svg
      width={size ?? 16}
      height={size ?? 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.71999 5.46665C2.84665 5.46665 2.97332 5.51332 3.07332 5.61332L7.41999 9.95999C7.73999 10.28 8.25999 10.28 8.57999 9.95999L12.9267 5.61332C13.12 5.41999 13.44 5.41999 13.6333 5.61332C13.8267 5.80665 13.8267 6.12665 13.6333 6.31999L9.28665 10.6667C8.57999 11.3733 7.42665 11.3733 6.71332 10.6667L2.36665 6.31999C2.17332 6.12665 2.17332 5.80665 2.36665 5.61332C2.46665 5.51999 2.59332 5.46665 2.71999 5.46665Z"
        fill={color}
      />
    </svg>
  );
});
export default ArrowUp;
